var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgRewind = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.94 4.22a4.385 4.385 0 0 0-1.83-2.047 4.14 4.14 0 0 0-2.66-.504 4.31 4.31 0 0 0-2.37 1.193V1.556a.54.54 0 1 0-1.08 0V4.23c0 .144.06.288.16.39.1.103.24.165.38.165h2.47c.3 0 .54-.247.54-.555a.546.546 0 0 0-.54-.556H3.84c.48-.484 1.1-.802 1.77-.895.68-.103 1.38.03 1.98.38.6.34 1.08.875 1.36 1.523.28.649.35 1.369.2 2.058-.15.69-.52 1.307-1.05 1.77-.53.452-1.18.73-1.87.771a3.102 3.102 0 0 1-1.94-.545 3.283 3.283 0 0 1-1.24-1.636.539.539 0 0 0-.69-.34.563.563 0 0 0-.33.71c.31.896.89 1.667 1.66 2.192.77.525 1.68.782 2.61.73.92-.05 1.8-.411 2.51-1.028.71-.618 1.2-1.451 1.4-2.377.21-.926.11-1.893-.27-2.768Z"
  })));
});
SvgRewind.displayName = "SvgRewind";
export default SvgRewind;